import stbAPIGateway from '../../../services/stbAPIGateway';

export default {
  async fetchJwt({ rootGetters }, { id, firstName, lastName, email }) {
    const axios = rootGetters['app/stbAxios'];

    const stbApi = stbAPIGateway(axios, process.env.API_URL);
    const response = await stbApi.getAhaJwt(id, firstName, lastName, email);
    return response.token;
  },
  async logoutAhaPortal() {
    await fetch(`${process.env.AHA_PORTAL_URL}portal_session/logout`, {
      method: 'GET',
      mode: 'no-cors',
      credentials: 'include'
    });
  }
};
